export default __webpack_public_path__ + "images/5fa112c608bd3ce71f5502dff125f817-icon-tiktok.svg";